import React from "react";
import PropTypes from "prop-types";

export default function Edit(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.292891 10.79C0.105356 10.9776 0 11.2319 0 11.4971V13C0 13.5523 0.447715 14 1 14H2.50286C2.76807 14 3.02243 13.8946 3.20996 13.7071L10.8173 6.09978C11.2078 5.70926 11.2078 5.0761 10.8173 4.68557L9.3144 3.18272C8.92387 2.79219 8.29071 2.79219 7.90018 3.18272L0.292891 10.79Z"
        fill="#3965DE"
      />
      <path
        d="M13.7725 2.04388L11.9561 0.227531C11.6527 -0.0758438 11.1587 -0.0758438 10.8554 0.227531L10.1389 0.943954C9.74842 1.33448 9.74842 1.96764 10.1389 2.35817L11.6418 3.86102C12.0323 4.25155 12.6655 4.25155 13.056 3.86102L13.7724 3.1446C14.0758 2.84123 14.0758 2.34726 13.7725 2.04388Z"
        fill="#3965DE"
      />
    </svg>
  );
}

Edit.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

Edit.defaultProps = {
  className: "",
  width: 168,
  height: 168
};
